const STAGE_MAP = {
  prospect: 'lead',
  qualifie: 'qualified',
  proposition: 'proposal',
  negociation: 'negotiation',
  conclu: 'closed',
};

export function computeStageDataFromProspects(prospects) {
  const stats = (prospects || []).reduce((acc, p) => {
    const key = p.status || 'prospect';
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  return {
    lead: stats.prospect || 0,
    qualified: stats.qualifie || 0,
    proposal: stats.proposition || 0,
    negotiation: stats.negociation || 0,
    closed: stats.conclu || 0,
  };
}

export function buildPipelineMetricsFromStageData(stageData) {
  const totalProspects = Object.values(stageData).reduce((acc, v) => acc + v, 0);
  return [
    {
      title: 'Prospects actifs',
      value: totalProspects.toString(),
      change: '',
      changeType: 'neutral',
      icon: 'Users',
      iconColor: 'var(--color-primary)',
      subtitle: 'Dans le périmètre sélectionné',
    },
    {
      title: 'Proposition',
      value: String(stageData.proposal || 0),
      change: '',
      changeType: 'neutral',
      icon: 'FileText',
      iconColor: 'var(--color-secondary)',
      subtitle: 'Offre en cours',
    },
    {
      title: 'Négociation',
      value: String(stageData.negotiation || 0),
      change: '',
      changeType: 'neutral',
      icon: 'Handshake',
      iconColor: 'var(--color-warning)',
      subtitle: 'Discussions avancées',
    },
    {
      title: 'Conclus',
      value: String(stageData.closed || 0),
      change: '',
      changeType: 'neutral',
      icon: 'CheckCircle',
      iconColor: 'var(--color-success)',
      subtitle: 'Convertis',
    },
  ];
}

export function mapProspectStage(status) {
  return STAGE_MAP[status] || 'lead';
}

export function remindersInMonth(prospects, year, monthIndex) {
  const start = new Date(year, monthIndex, 1);
  const end = new Date(year, monthIndex + 1, 0, 23, 59, 59, 999);
  return (prospects || [])
    .filter((p) => p.callbackAt)
    .map((p) => ({
      id: p._id,
      prospectId: p._id,
      fullName: p.fullName,
      company: p.company || '',
      callbackAt: new Date(p.callbackAt),
    }))
    .filter((r) => r.callbackAt >= start && r.callbackAt <= end)
    .sort((a, b) => a.callbackAt - b.callbackAt);
}

export function filterCallsByProspectIds(calls, prospectIdSet) {
  if (!prospectIdSet || prospectIdSet.size === 0) return [];
  return (calls || []).filter((c) => {
    const pid = c.prospect?._id || c.prospect;
    return prospectIdSet.has(String(pid));
  });
}
